import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/message';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from "primeng/components/common/selectitem";
import { EditListingCouponModel, ListingCoupon } from '../../../models/inModels/ListingCoupon';
import { MarketplaceCouponsService } from '../../../services/coupon/marketplace-coupon.service';

@Component({
	selector: 'app-coupons-edit',
	templateUrl: './coupons-edit.component.html',
	styleUrls: ['./coupons-edit.component.css']
})
export class MarketplaceCouponsEditComponent implements OnInit {
	loading = false;
	msg: Message[];
	id;
	model: EditListingCouponModel;
	code: string;
	products: SelectItem[];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private couponService: MarketplaceCouponsService) { }

	ngOnInit() {
		this.loading = true;
		this.id = this.route.snapshot.params.Id;
		this.couponService.get(this.id).subscribe(
			coupon => {
				this.model = new EditListingCouponModel(coupon);
				console.log(coupon);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	save(): void {
		this.loading = true;
		console.log("🚀 ~ CouponsEditComponent ~ save ~ this.model:", this.model)
		this.couponService.edit(this.model)
			.subscribe(
				coupon => {
					this.model = new EditListingCouponModel(coupon);
					this.loading = false;
					this.msg = [];
					this.msg.push({ severity: 'success', summary: 'Coupon Edited', detail: 'Coupon Successfully Edited.' });
				},
				error => {
					this.loading = false;
					this.msg = [];
					this.msg.push({ severity: 'error', summary: 'Error', detail: error });
				});
	}

	goBack() {
		this.router.navigate(['/listing-coupons']);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/marketplace-coupons/coupons-edit/coupons-edit.component.ts